import React, { useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import AudioRecorder from '@grnhse/seedling/lib/azalea/components/audio_recorder';
import { withLocalePrefix, tList } from 'shared/utils/translation';
import styled from 'styled-components';
import Collapsible from '@grnhse/seedling/lib/birch/components/collapsible';
import {
  Body,
  Link,
  SectionHeader,
} from '@grnhse/bonsai/lib/components/typography';
import { COLORS } from '@grnhse/bonsai/lib/core/colors';
import { useBonsai } from '@grnhse/bonsai/lib/hooks';

const t = withLocalePrefix('availability.candidate_pronunciation');

interface Props {
  recordingName?: string;
  recordingUrl?: string;
}

const Optional = styled.span`
  color: ${COLORS.mediumGray};
`;

const AudioRecorderWrapper = styled.div<{
  buttonColor: string;
  buttonHoverColor: string;
  font: string;
}>`
  margin-top: 15px;
  font-family: ${({ font }) => font};

  & div[data-provides='record-button'],
  & div[data-provides='playback-control'] {
    animation: none;
    border-color: ${({ buttonColor }) => buttonColor};

    & svg path {
      fill: ${({ buttonColor }) => buttonColor};
    }
  }

  & span[data-provides='audio-timer'] {
    font-family: ${({ font }) => font};

    & small {
      font-family: ${({ font }) => font};
    }
  }

  & span > button {
    & svg path {
      fill: ${COLORS.primaryTypography};
    }

    &:hover {
      background-color: ${({ buttonHoverColor }) => buttonHoverColor};
    }
  }
`;

export const BrandedPronunciationRecorder = (props: Props) => {
  const [showTips, setShowTips] = useState(false);
  const { buttonColor, dropdownSelectionColor, secondaryFont } = useBonsai();

  const toggleTips = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setShowTips(!showTips);
  };

  return (
    <section>
      <SectionHeader>
        {t('header')} <Optional>{t('optional')}</Optional>
      </SectionHeader>
      <div style={{ marginTop: '10px' }}>
        <Body>{t('subheader')}</Body>
      </div>
      <Collapsible id={'recording_tips'} isOpen={showTips}>
        <div style={{ marginTop: '10px' }}>
          <Body medium>{t('tips.header')}</Body>
          {tList('availability.candidate_pronunciation.tips.content').map(
            (tip) => (
              <Body key={tip}>{tip}</Body>
            )
          )}
          <Link
            href="https://support.greenhouse.io/hc/en-us/articles/360050488591"
            target="_blank"
            rel="noopener"
          >
            {t('tips.learn_more')}
          </Link>
        </div>
      </Collapsible>
      <div style={{ marginTop: '10px' }}>
        <Link href="#" onClick={toggleTips}>
          {showTips ? t('hide_tips') : t('show_tips')}
        </Link>
      </div>
      <AudioRecorderWrapper
        buttonColor={buttonColor}
        buttonHoverColor={dropdownSelectionColor}
        font={secondaryFont}
      >
        <AudioRecorder
          recordingName={props.recordingName}
          recordingData={props.recordingUrl}
        />
      </AudioRecorderWrapper>
    </section>
  );
};
